import type {
  usePimWorkflowHistory,
  WorkflowHistorySearch,
} from "../../services/use-pim-workflow-history"
import { Button } from "../ui/button"
import { WorkflowHistoryDetail } from "./workflow-history-detail"
import { WorkflowHistoryList } from "./workflow-history-list"

export function WorkflowHistoryResults({
  history,
  search,
  onChange,
}: {
  history: ReturnType<typeof usePimWorkflowHistory>
  search: WorkflowHistorySearch
  onChange: (search: WorkflowHistorySearch) => void
}) {
  const { list, detail } = history
  if (search.receiptId !== undefined) {
    return (
      <section className="space-y-4" aria-busy={detail.isFetching}>
        {!detail.data && (
          <Button
            onClick={() =>
              onChange({
                ...search,
                receiptId: undefined,
                targetAfter: undefined,
                attemptAfter: undefined,
              })
            }
          >
            All receipts
          </Button>
        )}

        {detail.isPending && (
          <p
            role="status"
            className="rounded-xl bg-card p-5 text-sm text-muted-foreground"
          >{`Loading receipt #${search.receiptId}…`}</p>
        )}

        {detail.error && (
          <p
            role="alert"
            className="text-sm text-destructive"
          >{`Could not load receipt #${search.receiptId}. ${detail.error.message} Use Refresh to retry.`}</p>
        )}

        {detail.data && (
          <WorkflowHistoryDetail data={detail.data} search={search} onChange={onChange} />
        )}
      </section>
    )
  }
  return (
    <section className="space-y-4" aria-busy={list.isFetching}>
      {list.isPending && (
        <p role="status" className="rounded-xl bg-card p-5 text-sm text-muted-foreground">
          Loading workflow receipts…
        </p>
      )}

      {list.error && (
        <p
          role="alert"
          className="text-sm text-destructive"
        >{`Could not load workflow history. ${list.error.message} Use Refresh to retry.`}</p>
      )}

      {list.data && <WorkflowHistoryList data={list.data} search={search} onChange={onChange} />}
    </section>
  )
}
